/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AccountingBankAccount from './accounting-bank-account';
import AccountingBankAccountDetail from './accounting-bank-account-detail';
import AccountingBankAccountUpdate from './accounting-bank-account-update';
import AccountingBankAccountDeleteDialog from './accounting-bank-account-delete-dialog';

const AccountingBankAccountRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AccountingBankAccount />} />
    <Route path="new" element={<AccountingBankAccountUpdate />} />
    <Route path=":id">
      <Route index element={<AccountingBankAccountDetail />} />
      <Route path="edit" element={<AccountingBankAccountUpdate />} />
      <Route path="delete" element={<AccountingBankAccountDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AccountingBankAccountRoutes;
